"use client";

import type { ComponentProps } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { BindableBigTextField } from "./BindableBigTextField";
import { BindableCodeField } from "./BindableCodeField";

/**
 * Dispatcher for `ConfigBindableCode` fields that declare
 * `markdown_mode_field`: while that sibling bool config field is true, the
 * value is edited with the markdown editor (`BindableBigTextField`);
 * otherwise with the verbatim plain-text editor (`BindableCodeField` — no
 * markdown round-trip, so no escape backslashes are ever injected). Both
 * editors read and write the same config value.
 */
export function BindableCodeOrBigTextField({
  markdownModeField,
  ...props
}: ComponentProps<typeof BindableCodeField> & {
  markdownModeField?: string;
}) {
  const form = useFormContext<Record<string, unknown>>();
  const markdownMode = useWatch({
    control: form.control,
    name: `${props.nodeId}.${markdownModeField ?? props.fieldKey}`,
    disabled: !markdownModeField,
  });
  if (markdownModeField && markdownMode === true) {
    return (
      <BindableBigTextField
        nodeId={props.nodeId}
        fieldKey={props.fieldKey}
        label={props.label}
        tooltip={props.tooltip}
        description={props.description}
        disabled={props.disabled}
        placeholder={props.placeholder}
        isRequired={props.isRequired}
        showOptionalLabel={props.showOptionalLabel}
        error={props.error}
        hideRawToggle
      />
    );
  }
  return <BindableCodeField {...props} />;
}
